var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("box" + (_vm.show ? ' selected' : ''))},[_c('i',{staticClass:"icon-set",on:{"click":_vm.toggle}}),_vm._v(" "),_c('div',{staticClass:"tip",on:{"click":_vm.send}},[_vm._v("取消收藏")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-df973bea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/space/collect/Set.vue
// module id = null
// module chunks = 